interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
}

const SIZE: Record<Required<LoadingSpinnerProps>['size'], string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-[3px]',
};

// Airbnb spinner — Rausch Red ring with subtle track
export function LoadingSpinner({ size = 'md', label = '불러오는 중…', className = '' }: LoadingSpinnerProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={`inline-flex items-center gap-2 text-body text-ink-muted ${className}`}
    >
      <span
        aria-hidden="true"
        className={`inline-block animate-spin rounded-full border-surface-muted border-t-primary ${SIZE[size]}`}
      />
      <span className="sr-only">{label}</span>
      {label && <span aria-hidden="true">{label}</span>}
    </span>
  );
}
